(function (Legacy) {
  Legacy.PhoneNumber = function (countryCode, areaCode, number, extension) {
    var self = this;
    self.countryCode = countryCode;
    self.areaCode = areaCode;
    self.number = number;
    self.extension = extension;

    self.format = function () {
      var formatted = "";
      var cc = self.countryCode;
      var area = self.areaCode;
      var number = self.number;
      var ext = self.extension;

      if (!cc) cc = "";
      if (!area) area = "";
      if (!number) number = "";
      if (!ext) ext = "";

      if (cc == "" && area == "" && number == "" && ext == "")
        return "";

      if (!self.isAmerican()) {
        if (cc != "") formatted = "+" + cc + " ";
        if (area != "") formatted += "(" + area + ") ";
        if (number != "") formatted += number;
        if (ext != "") formatted += " x " + ext;
      }
      else {
        if (area != "") formatted = "(" + area + ") ";
        if (number != "") formatted += number.substring(0, 3) + "-" + number.substring(3, 7);
        if (ext != "") formatted += " x " + ext;
      }

      return formatted;
    };

    self.isAmerican = function () {
      return self.isAmericanCountryCode() &&
        self.isAmericanAreaCode() &&
        self.isAmericanNumber()
    };

    self.isAmericanCountryCode = function () {
      var cc = self.countryCode;
      if (!cc)
        cc = "";
      else
        cc = cc.replace("0", "");
      return cc == "" || cc == "1" || cc == "11";
    };

    self.isAmericanAreaCode = function () {
      var area = self.areaCode;
      if (!area) area = "";
      return area == "" || area.length == 3;
    };

    self.isAmericanNumber = function () {
      var number = self.number;
      if (!number) number = "";
      return number.length == 7;
    };

    if (self.isAmericanCountryCode()) {
      if (self.number != null)
        self.number = number.replace(/[^0-9A-Za-z]/g, '');
    }
  };

  Legacy.PhoneNumber.parse = function (numberToParse) {
    if (numberToParse == null || numberToParse == "")
      return new Legacy.PhoneNumber();

    var cc = null, area = null, number = null, ext = null;
    var phone = numberToParse;

    // parse out country code
    if (phone.charAt(0) == '+') {
      var ccEndsAt = phone.indexOf(" ");
      if (ccEndsAt != -1) {
        cc = phone.substring(1, ccEndsAt);
        phone = phone.substring(ccEndsAt + 1, phone.length);
      }
      else {
        cc = phone.substring(1, 2);
        phone = phone.substring(2, phone.length)
      }
    }

    //strip out whitespace, -, ., etc.
    phone = phone.replace(/[^0-9A-Za-z]/g, '');

    // parse out extension
    var xAt = phone.indexOf('x');
    if (xAt != -1) {
      ext = phone.substring(xAt + 1, phone.length);
      phone = phone.substring(0, xAt);
    }

    // parse out area code and number
    if (phone.length <= 7) {
      number = phone;
    }
    else {
      area = phone.substring(0, 3);
      number = phone.substring(3, phone.length);
    }

    return new Legacy.PhoneNumber(cc, area, number, ext);
  };
})(this.Legacy = this.Legacy || {});